import React from 'react'
import './vision-mission.less'
import Reaching from '../../../images/handImageTwo.jpeg'

export default ()=>{
    return(
        <section className="vision-mission-container">
            <article className="about-content-image anim-three" data-delay="0s">
                <img src={Reaching} alt="Reaching.jpeg" />
            </article>
            <article className="about-content anim-three" data-delay="0s">
                <div className="vision">
                    <h4 className="sub-heading anim-three" data-delay="0.2s">
                        Vision
                    </h4>
                    <p className="about-text anim-three" data-delay="0.4s">
                        To power on to the future by supporting humanity and its causes so we can all live in a more
                        humane world
                    </p>
                </div>
                <div className="mission">
                    <h4 className="sub-heading anim-three" data-delay="0.6s">
                        Mission
                    </h4>
                    <p className="about-text anim-three" data-delay="0.8s">
                        To bridge the gap between social stratifications by advocating for people who have been forced
                        to hide under a façade.
                    </p>
                </div>
            </article>
        </section>
    )
}